import React from 'react'
import { ARTICLE_FEATURED_TYPES } from '../../constants'
import ArticleOverlay from '../utils/ArticleOverlay'
import Link from '../utils/Link'
import { type ListBoxProps } from './Types'

export default (props: ListBoxProps) => {
  const {
    className,
    featuredSize,
    featuredType,
    link,
    onMouseOver,
    onMouseOut,
    title
  } = props

  const isFeatured = ARTICLE_FEATURED_TYPES.COMMON.includes(featuredType)

  return (
    <li className={className} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
      <Link href={link}>
        <span className={`title${isFeatured ? ' label' : ''}`}>
          { title }
        </span>
        {
          isFeatured &&
          <ArticleOverlay className={`${featuredSize} ${featuredType}`}/>
        }
      </Link>
    </li>
  )
}
